module.exports = __webpack_public_path__ + "img/lesson.80387723.png";